"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCanvasPointerEvent = void 0;
/**
 * @public
 * Provides raw pointer events. Shouldn't typically be used unless implementing custom interaction handler.
 */
class OnCanvasPointerEvent {
    constructor(onPointerEvent) {
        this.onPointerEvent = onPointerEvent;
    }
    static registerListener(eventService, onEvent) {
        return eventService
            .getCategory(OnCanvasPointerEvent)
            .addTemporaryListener(new OnCanvasPointerEvent(onEvent));
    }
    static emit(eventService, eventType, $event) {
        const listeners = eventService
            .getCategory(OnCanvasPointerEvent)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onPointerEvent(eventType, $event);
        }
    }
}
exports.OnCanvasPointerEvent = OnCanvasPointerEvent;
OnCanvasPointerEvent.callbackKey = "onPointerEvent";
//# sourceMappingURL=on-canvas-pointer-event.js.map